export enum CognitiveAssessmentsTranslations {
  title = 'cognitiveassessmentstranslations.title',
  cognitiveTestResults = 'cognitiveassessmentstranslations.cognitiveTestResults',
  cognitiveTestNoConsentBoxValue = 'cognitiveassessmentstranslations.cognitiveTestNoConsentBoxValue',
}
